import React from "react";
import { reportUnexpectedError } from "../../error-reporter";

type Props = {
  children: React.ReactNode;
  // 開閉設定を永続化したい場合に、
  // 当該設定をlocalStorageで保持するための
  // キー名を指定する。
  // 新しいメニューを追加して強制的に一度オープンにしたい
  // などの場合は、新しいkeyの名前を指定すればよい。
  //
  // 指定がない場合、開閉設定は揮発する。
  // またその場合、デフォルトでメニューは開いた状態になる。
  persistKey?: string;
};

const DEFAULT_SHOW_MENU_STATE = true;

export const MenuListWrapper: React.FC<Props> = ({ children, persistKey }) => {
  const initialShowMenuState = React.useMemo(() => {
    if (!persistKey) {
      return DEFAULT_SHOW_MENU_STATE;
    }

    try {
      const persistedValue = localStorage.getItem(persistKey);
      if (typeof persistedValue !== "string") {
        return DEFAULT_SHOW_MENU_STATE;
      }
      return persistedValue === "true";
    } catch (error) {
      // localStorage API の意図しないエラーをハンドルしておく
      reportUnexpectedError(error);
      return true;
    }
  }, [persistKey]);

  const [showMenu, setShowMenu] = React.useState(initialShowMenuState);

  React.useEffect(() => {
    if (!persistKey) {
      return;
    }

    try {
      localStorage.setItem(persistKey, String(showMenu));
    } catch (error) {
      // localStorage API の意図しないエラーをハンドルしておく
      reportUnexpectedError(error);
    }
  }, [persistKey, showMenu]);

  return (
    <>
      <aside className={`is-menu-pane aside ${showMenu ? "" : "is-hidden"}`}>
        <div
          onClick={() => {
            setShowMenu(false);
          }}
          className="is-clickable has-text-grey is-size-7 mb-5"
        >
          メニューを閉じる
          <span className="icon">
            <i className="fas fa-chevron-left"></i>
          </span>
        </div>
        <div
          style={{
            borderTop: "1px solid #eee",
            width: "60%",
          }}
          className="mb-5"
        />
        {children}
      </aside>
      <aside
        className={`is-clickable ${showMenu ? "is-hidden" : ""}`}
        style={{ borderRight: "1px solid #eee" }}
        onClick={() => {
          setShowMenu(true);
        }}
      >
        <div className="has-text-grey mx-1 my-1">
          <span className="icon">
            <i className="fas fa-chevron-right"></i>
          </span>
        </div>
      </aside>
    </>
  );
};
